export default __webpack_public_path__ + "3b10447207ec9c90509c2d9a26f45a7e.png";